import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { CreateQuestion } from "../../create-questions/entities/create-question";
import { ChapterReqModel } from "@boi/shared-models";

@Injectable()
export class CreateQuestionRepo extends Repository<CreateQuestion> {
    constructor(private dataSource: DataSource) {
        super(CreateQuestion, dataSource.createEntityManager());
    }
    async getMarksByChapter(req: ChapterReqModel) {
        const classData = this.createQueryBuilder('cq')
            .select(`cq.marks as marks`)
            .where(`cq.class = '${req.classId}'`)
        if (req.subject) {
            classData.andWhere(`cq.subject='${req.subject}'`)
        }
        if (req.chapter) {
            classData.andWhere(`cq.chapter='${req.chapter}'`)
        }
        classData.groupBy('cq.marks')
        const data = await classData.getRawMany();
        return data;
    }

    async getMarksByClass(classId?: number) {
        const qb = this.createQueryBuilder('cq')
            .select('DISTINCT cq.marks', 'marks')
            .where('cq.marks IS NOT NULL');

        if (classId) {
            qb.andWhere('cq.class = :classId', { classId });
        }

        const result = await qb.getRawMany();
        return result.map(row => row.marks);
    }

    async getDistinctMarksFromCreateQuestions(req: ChapterReqModel) {
        const qb = this.createQueryBuilder('cq')
            .select('DISTINCT cq.marks', 'marks')
            .where('cq.marks IS NOT NULL');

        if (req.classId) {
            qb.andWhere('cq.class = :classId', { classId: req.classId });
        }

        if (req.subject) {
            qb.andWhere('cq.subject = :subject', { subject: req.subject });
        }

        if (req.chapter) {
            qb.andWhere('cq.chapter = :chapter', { chapter: req.chapter });
        }

        const rows = await qb.getRawMany();
        return rows.map(row => row.marks);
    }

}